import React from 'react';

const BackupPanel = () => {
  const handleBackup = (type) => {
    const urlMap = {
      web: '/api/backup/web',
      db: '/api/backup/db',
      all: '/api/backup/all',
    };

    const url = urlMap[type];
    if (!url) return;

    window.open(url, '_blank'); // Open in new tab for download
  };

  return (
    <div style={styles.container}>
      <h1>📦 Website Backup Panel</h1>
      <button style={styles.button} onClick={() => handleBackup('web')}>
        Backup Web Files
      </button>
      <button style={styles.button} onClick={() => handleBackup('db')}>
        Backup Database
      </button>
      <button style={styles.button} onClick={() => handleBackup('all')}>
        Backup Both & Email
      </button>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '50px',
  },
  button: {
    margin: '10px',
    padding: '15px 30px',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

export default BackupPanel;
